import React from 'react';
export var StandaloneImage = function (_a) {
    var src = _a.src, width = _a.width, height = _a.height, alt = _a.alt, style = _a.style;
    return (React.createElement("img", { src: src, width: width, height: height, style: style, alt: alt }));
};
var ConfigContext = React.createContext({
    renderComments: true,
    wrapPlaceholders: false,
    implementations: { Image: StandaloneImage },
});
export var ConfigProvider = ConfigContext.Provider;
export var useConfig = function () { return React.useContext(ConfigContext); };
//# sourceMappingURL=config-context.js.map